import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import { errorMessage } from 'helpers/common';
import * as Sentry from "@sentry/react";

const FIELD_TYPE_FIXED = ['fixed'];
const FIELD_TYPE_FREE = ['free'];
const FIELD_TYPE_SYSTEM = ['system'];
const FIELD_TYPE_CONDITIONAL = ['conditional'];
const FIELD_TYPE_CALCULATION_RELATED = ['calculation_related'];

const fetchFields = createAsyncThunk('fetchFields', async (_, { getState, rejectWithValue }) => {
  try {
    const { data, status } = await api.get('/settings/fields');
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch free fields'));
  }
});

export const fieldsSlice = createSlice({
  name: 'fields',
  initialState: {
    all: null,
    allCustomNames: null,
    balancedScorecardFields: null,
    fixedAndBalancedScorecardFields: null,
    fixedFields: null,
    freeFields: null,
    systemFields: null,
    calculationRelatedFields: null,
    conditionalFields: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFields.fulfilled, (state, action) => {
        let payload = action.payload.data;

        state.all = payload;
        state.balancedScorecardFields = payload.filter(field => FIELD_TYPE_FIXED.includes(field.field_type) && field.is_balanced_scorecard_specific);
        state.fixedAndBalancedScorecardFields = payload.filter(field => FIELD_TYPE_FIXED.includes(field.field_type));
        state.fixedFields = payload.filter(field => FIELD_TYPE_FIXED.includes(field.field_type) && !field.is_balanced_scorecard_specific);
        state.freeFields = payload.filter(field => FIELD_TYPE_FREE.includes(field.field_type));
        state.systemFields = payload.filter(field => FIELD_TYPE_SYSTEM.includes(field.field_type));
        state.calculationRelatedFields = payload.filter(field => FIELD_TYPE_CALCULATION_RELATED.includes(field.field_type));
        state.conditionalFields = payload.filter(field => FIELD_TYPE_CONDITIONAL.includes(field.field_type));

        const customNames = {};
        for (const field of payload) {
          customNames[field.translation_key] = field?.custom_name || null;
        }
        state.allCustomNames = customNames;
      })
  }
});

export const getAllFields = (state) => state.fields.all;
export const getAllCustomNames = (state) => state.fields.allCustomNames;
export const getSystemFields = (state) => state.fields.systemFields;
export const getConditionalFields = (state) => state.fields.conditionalFields;
export const getFixedFields = (state) => state.fields.fixedFields;
export const getFreeFields = (state) => state.fields.freeFields;
export const getCalculationRelatedFields = (state) => state.fields.calculationRelatedFields;
export const getBalancedScorecardFields = (state) => state.fields.balancedScorecardFields;
export const getFixedAndBalancedScorecardFields = (state) => state.fields.fixedAndBalancedScorecardFields;

export { fetchFields };

export default fieldsSlice.reducer;
